import React from 'react'
import MaterialSymbol from '../material-symbol'

const Launch = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="launch" {...props} />
))

Launch.displayName = 'Launch'

export default Launch
